import { createAction, props } from '@ngrx/store';
import { actionName } from '../store-util';
import { PassportUser, TokenResponse, User } from '../../types';

const STORE_NAME = 'USER_MODULE';

const initUser = createAction(actionName(STORE_NAME, 'Init User'));
const setUser = createAction(actionName(STORE_NAME, 'Set User'), props<{ user: User | PassportUser }>());
const addUser = createAction(actionName(STORE_NAME, 'Add User'), props<{ tokenResponse: TokenResponse }>());

const stopUpdate = createAction(actionName(STORE_NAME, 'Stop Update'));

export const UserActions = {
  initUser,
  setUser,
  addUser,
  stopUpdate,
};
